import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { SelfPickupIcon, TruckDeliveryIcon } from 'assets';
import { SectionContainer, StyledButton, ToolTip } from 'components/shared';
import { OrderAddress } from 'interfaces';
import { Card } from 'storybook';

import styles from './OverviewDeliverySection.module.css';

type OverviewDeliverySectionProps = {
   address: OrderAddress | 'SELF_PICKUP' | null;
   storageAddress?: string;
   onClickEdit?: () => void;
   disabledEditAction?: boolean;
   viewMode: 'SUPPLIER' | 'CLIENT';
};

const OverviewDeliverySection = ({
   address,
   storageAddress,
   onClickEdit,
   disabledEditAction,
   viewMode,
}: OverviewDeliverySectionProps) => {
   const { t } = useTranslation();

   const NO_STORAGE_ADDRESS_TEXTS: { [key: string]: string } = {
      SUPPLIER: t('overviewDelivery.noStorageSupplier'),
      CLIENT: t('overviewDelivery.noStorageClient'),
   };

   return (
      <SectionContainer title={t('delivery.title')}>
         {onClickEdit && (
            <ToolTip
               content={t('overviewDelivery.tooltip')}
               variant="right"
               visible={disabledEditAction}
            >
               <StyledButton
                  variant="outlined-primary"
                  text={t('common.editDelivery')}
                  onClick={onClickEdit}
                  disabled={disabledEditAction}
               />
            </ToolTip>
         )}
         <Card
            title={
               address === 'SELF_PICKUP'
                  ? t('delivery.selfPickupTitle')
                  : t('delivery.deliveryTitle')
            }
            icon={address === 'SELF_PICKUP' ? <SelfPickupIcon /> : <TruckDeliveryIcon />}
            bottomContent={
               address === 'SELF_PICKUP' ? (
                  <p
                     className={classNames(styles.cardText, {
                        [styles.supplierNoStorageAddressText]:
                           address === 'SELF_PICKUP' && !storageAddress && viewMode === 'SUPPLIER',
                     })}
                  >
                     {storageAddress || NO_STORAGE_ADDRESS_TEXTS[viewMode]}
                  </p>
               ) : (
                  <p className={styles.cardText}>
                     {address ? address.name : ''}
                     <br />
                     {address ? `${address.street}, ${address.zipCode} ${address.city}` : ''}
                  </p>
               )
            }
            className={styles.addressCard}
         />
      </SectionContainer>
   );
};

export default OverviewDeliverySection;
